import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const Column = styled.div`
    width: 100%;
    display: flex;
    padding-top: ${({ padding }) => `${padding || 12}px`};
    padding-bottom: ${({ padding }) => `${padding || 12}px`};
    flex: 1;
    flex-direction: column;
    justify-content: space-around;
    border-bottom: ${({ border }) => border ? '1px solid rgb(9, 207, 253, 0.5)' : ''};
    justify-content: ${({ justifyContent }) => justifyContent ? justifyContent : 'center'};
`;

export const Title = styled.span`
    font-size: 30px;
    color: #F9F9F9;
    font-weight: bold;
`;

export const Subtitle = styled.span`
    font-size: 16px;
    color: #B5B5B5;
    padding-bottom: 8px;
`;

export const Number = styled.span`
    font-size: ${({fontSize}) => fontSize || '22px'};
    color: #F9F9F9;
    text-align: center;
    font-weight: bold;
    padding: 6px 0;
`;

export const Description = styled.span`
    font-size: 12px;
    color: #F9F9F9;
    text-align: center;
    padding: 6px 0;
`;

export const Button = styled.button`
    padding: 12px 24px;
    background-color: #D73E67;
    color: #F9F9F9;
    font-weight: bold;
    border-radius: 20px;
    border-width: 0;
    cursor: pointer;
    
    &:focus {
        outline: 0;
    }
    
    &:hover {
        background-color: #bd365f;
    }
`;

export const TextContainer = styled.div`
    color: #ffffff;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    padding-top: ${({ padding }) => `${padding || 0}px`};
`;
